export default __webpack_public_path__ + "static/media/apple-13.a0a9dba9.svg";